export const firestoreConstants = {
  team: 'team',
  courses: 'courses'
}
